// extracted by mini-css-extract-plugin
export default {"dm-icons":"PmrDmIcons_dm-icons__biSki","dm-icon":"PmrDmIcons_dm-icon__tkvRt"};